// How long a failure or timeout notice stays on screen before the journey falls
// through to a normal lead. Shared so every screen waits the same amount.
export const FALL_THROUGH_DELAY_MS = 3000;

// How long each "booking in progress" message stays up on the review screen
// before the next one, while the supplier's booking call is in flight.
export const BOOKING_PROGRESS_INTERVAL_MS = 3000;

// Why a journey ended early, sent as the reason tag on the fall-through metric.
export const FALL_THROUGH_REASONS = {
  TIMED_OUT: 'timedOut',
  LOCATION_LOOKUP_FAILED: 'locationLookupFailed',
  NO_LOCATIONS: 'noLocations',
  SOLAR_LOAD_FAILED: 'solarLoadFailed',
  SOLAR_VERIFY_FAILED: 'solarVerifyFailed',
  NO_SOLAR_POTENTIAL: 'noSolarPotential',
  SLOTS_LOOKUP_FAILED: 'slotsLookupFailed',
  NO_SLOTS: 'noSlots',
  BOOKING_FAILED: 'bookingFailed',
  BOOKING_NOT_CONFIRMABLE: 'bookingNotConfirmable',
  SUBSCRIPTION_MISMATCH: 'subscriptionMismatch',
  LEAD_STATUS_FAILED: 'leadStatusFailed',
};
